import { useCallback } from 'react'
import type { TGetProjectsCursorQueryParams, TGetProjectsQueryParams, TProjectsCursorPage } from '../api/types'
import { CURSOR_LIST_PAGE_SIZE } from '../consts/api'
import { useWindowedCursorList } from './useWindowedCursorList'

type LoadProjectsPage = (
  arg: TGetProjectsCursorQueryParams,
  preferCacheValue?: boolean,
) => { unwrap: () => Promise<TProjectsCursorPage> }

export function useProjectsWindowedPage(
  resetKey: string | number,
  loadPage: LoadProjectsPage,
  queryArgs: TGetProjectsQueryParams,
) {
  const fetchPage = useCallback(
    async (cursor: string | null) => {
      const data = await loadPage({ ...queryArgs, cursor, limit: CURSOR_LIST_PAGE_SIZE }, true).unwrap()
      return {
        items: data.items ?? [],
        nextCursor: data.meta?.next_cursor ?? null,
      }
    },
    [loadPage, queryArgs],
  )

  return useWindowedCursorList({
    resetKey,
    fetchPage,
  })
}

export { EMPTY_PROJECTS_QUERY_ARGS } from './useProjectsCursorPage'
